import * as i0 from '@angular/core';
import { Injectable, Component, Optional, NgModule } from '@angular/core';
import * as i6 from '@angular/forms';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CheckoutSupportedDeliveryModesQueryReloadEvent } from '@spartacus/checkout/base/root';
import * as i1 from '@spartacus/core';
import { facadeFactory, GlobalMessageType, CxDatePipe, I18nModule, provideDefaultConfigFactory } from '@spartacus/core';
import * as i4 from '@spartacus/storefront';
import { DatePickerModule, CardModule, provideOutlet, OutletPosition } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import { CartOutlets } from '@spartacus/cart/base/root';
import '@spartacus/order/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function DeliveryModeDatePickerComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 3);
    i0.ɵɵpipe(2, "cxDate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 3, ctx_r0.getRequestedDeliveryDateCardContent(i0.ɵɵpipeBind1(2, 1, ctx_r0.requestedRetrievalAt))));
  }
}
function DeliveryModeDatePickerComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "form", 5)(2, "label", 6)(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8)(7, "cx-date-picker", 9);
    i0.ɵɵlistener("update", function DeliveryModeDatePickerComponent_ng_container_0_ng_template_2_Template_cx_date_picker_update_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.setRequestedDeliveryDate());
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "requestedDeliveryDate.datePickerLabel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r0.form.get("requestDeliveryDate"))("min", ctx_r0.earliestRetrievalAt)("required", true);
  }
}
function DeliveryModeDatePickerComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DeliveryModeDatePickerComponent_ng_container_0_ng_container_1_Template, 4, 5, "ng-container", 2)(2, DeliveryModeDatePickerComponent_ng_container_0_ng_template_2_Template, 8, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const datePickerEnabled_r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isDatePickerReadOnly)("ngIfElse", datePickerEnabled_r3);
  }
}
function OrderOverviewDeliveryDateComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 1);
    i0.ɵɵpipe(2, "cxDate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 3, ctx_r0.getRequestedDeliveryDateCardContent(i0.ɵɵpipeBind1(2, 1, ctx_r0.order == null ? null : ctx_r0.order.requestedRetrievalAt))));
  }
}
const REQUESTED_DELIVERY_DATE_FEATURE = 'requestedDeliveryDate';
const REQUESTED_DELIVERY_DATE_CORE_FEATURE = 'requestedDeliveryDateCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function requestedDeliveryDateFacadeFactory() {
  return facadeFactory({
    facade: RequestedDeliveryDateFacade,
    feature: REQUESTED_DELIVERY_DATE_FEATURE,
    methods: ['setRequestedDeliveryDate']
  });
}
let RequestedDeliveryDateFacade = /*#__PURE__*/(() => {
  class RequestedDeliveryDateFacade {
    static {
      this.ɵfac = function RequestedDeliveryDateFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RequestedDeliveryDateFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RequestedDeliveryDateFacade,
        factory: () => requestedDeliveryDateFacadeFactory(),
        providedIn: 'root'
      });
    }
  }
  return RequestedDeliveryDateFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let DateValidationService = /*#__PURE__*/(() => {
  class DateValidationService {
    /**
     * Validates if the string is containing a date string.
     * @param value Date string in the format 'dd-mm-yyy'
     * @returns true if valid, false if invalid
     */
    isDateStringValid(value) {
      return value != null && value !== undefined && value.length > 0 && !isNaN(this.getDateFromDateString(value).getDate() //convert 'dd-mm-yyyy' into 'mm/dd/yyyy'
      );
    }
    /**
     * Returns a Date object from a date string in the format 'dd-mm-yyy'
     * @param value Date string in the format 'dd-mm-yyy'
     */
    getDateFromDateString(value) {
      return new Date(value.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    }
    /**
     * Checks if the source date is greater than or equal to the target
     * @param source Date string in the format 'dd-mm-yyy'
     * @param target Date string in the format 'dd-mm-yyy'
     * @returns true if `source` date is greater than or equal to `target` date
     */
    isDateGreaterOrEqual(source, target) {
      if (source.length === 0 || target.length === 0) {
        return false;
      }
      const d1 = this.getDateFromDateString(source);
      const d2 = this.getDateFromDateString(target);
      return d1 < d2 ? false : true;
    }
    static {
      this.ɵfac = function DateValidationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DateValidationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DateValidationService,
        factory: DateValidationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DateValidationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DeliveryModeDatePickerComponent = /*#__PURE__*/(() => {
  class DeliveryModeDatePickerComponent {
    constructor(datePipe, requestedDelDateFacade, dateValidationService, eventService, translation, globalMessageService, deliveryOutlet) {
      this.datePipe = datePipe;
      this.requestedDelDateFacade = requestedDelDateFacade;
      this.dateValidationService = dateValidationService;
      this.eventService = eventService;
      this.translation = translation;
      this.globalMessageService = globalMessageService;
      this.deliveryOutlet = deliveryOutlet;
      this.cartEntry = {};
      this.subscription = new Subscription();
      this.form = new FormGroup({
        requestDeliveryDate: new FormControl()
      });
      this.isDatePickerReadOnly = true;
    }
    ngOnInit() {
      if (this.deliveryOutlet?.context$) {
        this.subscription.add(this.deliveryOutlet.context$.subscribe(context => {
          this.cartEntry = context?.item;
          this.isDatePickerReadOnly = context?.readonly || false;
        }));
      }
      if (this.isEarliestRetrievalDatePresent()) {
        this.earliestRetrievalAt = this.cartEntry.earliestRetrievalAt;
      }
      if (this.isRequestedDeliveryDatePresent()) {
        this.requestedRetrievalAt = this.cartEntry.requestedRetrievalAt;
      } else {
        //set the value of requestedRetrievalAt as earliestRetrievalAt and update occ.
        this.requestedRetrievalAt = this.earliestRetrievalAt;
        this.form.patchValue({
          requestDeliveryDate: this.requestedRetrievalAt
        });
        this.setRequestedDeliveryDate();
      }
      this.form.patchValue({
        requestDeliveryDate: this.requestedRetrievalAt
      });
    }
    isEarliestRetrievalDatePresent() {
      return this.dateValidationService.isDateStringValid(this.cartEntry?.earliestRetrievalAt);
    }
    isRequestedDeliveryDatePresent() {
      return this.dateValidationService.isDateStringValid(this.cartEntry?.requestedRetrievalAt);
    }
    getRequestedDeliveryDateCardContent(isoDate) {
      return this.translation.translate('requestedDeliveryDate.readOnlyTextLabel').pipe(filter(() => Boolean(isoDate)), map(textTitle => {
        return {
          text: [textTitle, isoDate]
        };
      }));
    }
    setRequestedDeliveryDate() {
      const userId = this.cartEntry?.user?.uid || '';
      const cartId = this.cartEntry?.code || '';
      const requestedDate = this.form?.get('requestDeliveryDate')?.value || '';
      if (userId.length === 0 || cartId.length === 0 || requestedDate.length === 0 || !this.dateValidationService.isDateStringValid(requestedDate) || !this.dateValidationService.isDateGreaterOrEqual(requestedDate, this.earliestRetrievalAt || '')) {
        return;
      }
      this.subscription.add(this.requestedDelDateFacade.setRequestedDeliveryDate(userId, cartId, requestedDate).subscribe({
        next: () => {
          this.eventService.dispatch({}, CheckoutSupportedDeliveryModesQueryReloadEvent);
          this.globalMessageService.add({
            key: 'requestedDeliveryDate.successMessage'
          }, GlobalMessageType.MSG_TYPE_INFO);
        },
        error: error => {
          if (error && this.getErrors(error)?.length) {
            this.globalMessageService.add({
              key: 'requestedDeliveryDate.errorMessage'
            }, GlobalMessageType.MSG_TYPE_ERROR);
          }
        }
      }));
    }
    getErrors(response) {
      return (response.error?.errors).filter(error => error?.type === 'UnknownResourceError');
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function DeliveryModeDatePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DeliveryModeDatePickerComponent)(i0.ɵɵdirectiveInject(i1.CxDatePipe), i0.ɵɵdirectiveInject(RequestedDeliveryDateFacade), i0.ɵɵdirectiveInject(DateValidationService), i0.ɵɵdirectiveInject(i1.EventService), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i1.GlobalMessageService), i0.ɵɵdirectiveInject(i4.OutletContextData, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DeliveryModeDatePickerComponent,
        selectors: [["cx-request-delivery-date"]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([CxDatePipe])],
        decls: 1,
        vars: 1,
        consts: [["datePickerEnabled", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], [3, "content"], [1, "form-check"], [3, "formGroup"], [1, "row"], [1, "pl-4", "col-8"], [1, "col-4"], [3, "update", "control", "min", "required"]],
        template: function DeliveryModeDatePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DeliveryModeDatePickerComponent_ng_container_0_Template, 4, 2, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isEarliestRetrievalDatePresent());
          }
        },
        dependencies: [i5.NgIf, i4.DatePickerComponent, i6.ɵNgNoValidate, i6.NgControlStatusGroup, i6.FormGroupDirective, i4.CardComponent, i5.AsyncPipe, i1.TranslatePipe, i1.CxDatePipe],
        encapsulation: 2
      });
    }
  }
  return DeliveryModeDatePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OrderOverviewDeliveryDateComponent = /*#__PURE__*/(() => {
  class OrderOverviewDeliveryDateComponent {
    constructor(dateValidationService, translation, orderOutlet) {
      this.dateValidationService = dateValidationService;
      this.translation = translation;
      this.orderOutlet = orderOutlet;
      this.subscription = new Subscription();
    }
    ngOnInit() {
      if (this.orderOutlet?.context$) {
        this.subscription.add(this.orderOutlet.context$.subscribe(context => this.order = context?.item));
      }
    }
    isRequestedDeliveryDatePresent() {
      return this.dateValidationService.isDateStringValid(this.order?.requestedRetrievalAt);
    }
    getRequestedDeliveryDateCardContent(isoDate) {
      return this.translation.translate('requestedDeliveryDate.readOnlyTextLabel').pipe(filter(() => Boolean(isoDate)), map(textTitle => {
        return {
          title: textTitle,
          text: [isoDate]
        };
      }));
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function OrderOverviewDeliveryDateComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OrderOverviewDeliveryDateComponent)(i0.ɵɵdirectiveInject(DateValidationService), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i4.OutletContextData, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OrderOverviewDeliveryDateComponent,
        selectors: [["cx-order-overview-delivery-date"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [3, "content"]],
        template: function OrderOverviewDeliveryDateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, OrderOverviewDeliveryDateComponent_ng_container_0_Template, 4, 5, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.order && ctx.isRequestedDeliveryDatePresent());
          }
        },
        dependencies: [i5.NgIf, i4.CardComponent, i5.AsyncPipe, i1.CxDatePipe],
        encapsulation: 2
      });
    }
  }
  return OrderOverviewDeliveryDateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RequestedDeliveryDateComponentsModule = /*#__PURE__*/(() => {
  class RequestedDeliveryDateComponentsModule {
    static {
      this.ɵfac = function RequestedDeliveryDateComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RequestedDeliveryDateComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RequestedDeliveryDateComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, DatePickerModule, I18nModule, ReactiveFormsModule, CardModule]
      });
    }
  }
  return RequestedDeliveryDateComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// Imported for side effects (module augmentation)

/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultRequestedDeliveryDateComponentsConfig() {
  const config = {
    featureModules: {
      [REQUESTED_DELIVERY_DATE_FEATURE]: {
        cmsComponents: ['DeliveryModeDatePickerComponent', 'OrderOverviewDeliveryDateComponent']
      },
      // by default core is bundled together with components
      [REQUESTED_DELIVERY_DATE_CORE_FEATURE]: REQUESTED_DELIVERY_DATE_FEATURE
    }
  };
  return config;
}
let RequestedDeliveryDateRootModule = /*#__PURE__*/(() => {
  class RequestedDeliveryDateRootModule {
    static {
      this.ɵfac = function RequestedDeliveryDateRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RequestedDeliveryDateRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RequestedDeliveryDateRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: CartOutlets.DELIVERY_MODE,
          position: OutletPosition.AFTER,
          component: DeliveryModeDatePickerComponent
        }), provideOutlet({
          id: CartOutlets.ORDER_OVERVIEW,
          position: OutletPosition.AFTER,
          component: OrderOverviewDeliveryDateComponent
        }), provideDefaultConfigFactory(defaultRequestedDeliveryDateComponentsConfig)]
      });
    }
  }
  return RequestedDeliveryDateRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DeliveryModeDatePickerComponent, OrderOverviewDeliveryDateComponent, REQUESTED_DELIVERY_DATE_CORE_FEATURE, REQUESTED_DELIVERY_DATE_FEATURE, RequestedDeliveryDateComponentsModule, RequestedDeliveryDateFacade, RequestedDeliveryDateRootModule, defaultRequestedDeliveryDateComponentsConfig, requestedDeliveryDateFacadeFactory };
